
import React, { useCallback, useContext, useState } from "react";
import { Box, Card, CardMedia, IconButton, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { CloseRounded, DeleteRounded } from "@mui/icons-material";
import { AddCircleRounded } from "resource/muiImport";
import AddJobOrderFileDialog from "../AddJobOrderFileDialog";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { jobOrderApiNm } from "constants/jobOrderConstant";
import { alertConfirmDelete } from "components/Alert";
import dayjs from "dayjs";
import FullScreenImage from "pages/FullScreenImage/FullScreenImage";

const FilePreviewComponent = ({ filesData, jobOrdId, joData, onPettyCashDialogFinish, readOnly, label="ไฟล์แนบ" }) => {

  const { ax } = useContext(GlobalStateContext);
  const [selectedImage, setSelectedImage] = useState(null);
  const [dialogAddJobOrderFileOpen, setDialogAddJobOrderFileOpen] = useState(false);

  const handleDeleteFile = useCallback((jobOrdFileId) => (e) => {
    e.stopPropagation(); // Prevent closing the preview
    alertConfirmDelete(() => {
      ax.post(jobOrderApiNm.deleteJobOrderFile, { JobOrdFileId: jobOrdFileId }).then((value) => {
        if (value.data) {
          setSelectedImage(null);
          onPettyCashDialogFinish && onPettyCashDialogFinish();
        }
      });
    });
  }, [ax, onPettyCashDialogFinish]);


  return (
    <BoxFC sx={{ gap: 0, height: 162 }}>
      <BoxFR>
        <Typography fontWeight="bold">{label} ({filesData.length})</Typography>
        {!readOnly &&
          <IconButton sx={{ p: 0 }} onClick={() => { setDialogAddJobOrderFileOpen(true) }}>
            <AddCircleRounded color="primary" />
          </IconButton>
        }
      </BoxFR>
      <Box flex={1} sx={{ overflowX: "scroll" }}>
        <BoxFR sx={{ gap: 1, p: 0 }}>
          {filesData.map((file) => (
            <Card
              key={file.JobOrdFileId}
              sx={{
                width: 120,
                height: 120,
                cursor: "pointer",
                position: "relative",
                flexShrink: 0,
                "&:hover": {
                  boxShadow: 4
                }
              }}
              onClick={() => setSelectedImage(file)}
            >
              <CardMedia
                component="img"
                height="120"
                image={file.Url}
                alt={file.FileNm}
                sx={{ objectFit: "cover" }}
              />
            </Card>
          ))}
        </BoxFR>
      </Box>

      {/* Full screen image preview */}
      {selectedImage && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: "rgba(0, 0, 0, 0.9)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2
          }}
          onClick={() => setSelectedImage(null)}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "white"
            }}
            onClick={() => setSelectedImage(null)}
          >
            <CloseRounded />
          </IconButton>
          {!readOnly &&
            <IconButton
              sx={{
                position: "absolute",
                top: 16,
                left: 16,
                color: "white",
                bgcolor: "error.main",
                "&:hover": {
                  bgcolor: "error.dark"
                }
              }}
              onClick={handleDeleteFile(selectedImage.JobOrdFileId)}
            >
              <DeleteRounded />
            </IconButton>

          }

          <Typography
            sx={{
              position: "absolute",
              top: 16,
              left: "50%",
              transform: "translateX(-50%)",
              color: "white",
              bgcolor: "rgba(0, 0, 0, 0.5)",
              px: 2,
              py: 1,
              borderRadius: 1,
              zIndex: 1
            }}
          >
            {`${selectedImage.Label || ""} by: ${selectedImage.DrvNNm || selectedImage.ModAccNNm || "-"} at ${selectedImage.AddTm ? dayjs(selectedImage.AddTm).format("DD/MM/YYYY HH:mm") : "-"}`}
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "95%",
              mt:6
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <FullScreenImage linkUrl={selectedImage.Url} width="100%" height="100%" />
          </Box>
        </Box>
      )}

      <AddJobOrderFileDialog
        selectedId={jobOrdId}
        selectedRow={joData}
        dialogOpen={dialogAddJobOrderFileOpen}
        setDialogOpen={setDialogAddJobOrderFileOpen}
        onFinish={onPettyCashDialogFinish} />
    </BoxFC>
  );
};

export default React.memo(FilePreviewComponent);
